module.exports = __webpack_public_path__ + "static/media/banner-pattern.67a7df5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-pattern.png
// module id = 837
// module chunks = 7